<template>
  <a
    :href="url"
    class="js-suggest-item search-product"
    :data-html="name"
    @click="$emit('clickHandler')"
  >
    <div class="search-product__image-block">
      <img :src="img" alt="" class="search-product__image-pic" />
    </div>
    <div class="search-product__container">
      <span
        class="search-product__title"
        v-html="getSearchCaption(name, query.trim().toLowerCase())"
      ></span>
      <div class="search-product__price">
        <div class="search-product__price-current">
          {{ price | priceFormatted('', true, false) }}
        </div>
        <div
          v-if="price < priceBase"
          class="search-product__price-old"
        >
          <div class="search-product__price-old-value">
            {{ priceBase | priceFormatted() }}
          </div>
          <div
            v-if="percentDiscount !== null"
            class="search-product__price-discount"
          >
            <div class="discount _big">
              -{{ percentDiscount }}%
            </div>
          </div>
        </div>
      </div>
    </div>
  </a>
</template>

<script>
import AutocompleteMixin from '@/js/helpers/mixins/AutocompleteMixin';

export default {
  name: 'SearchProduct',
  mixins: [AutocompleteMixin],
  props: {
    url: {
      type: String,
      default: '',
    },
    img: {
      type: String,
      default: '/local/assets/img/not-image/Not_image_book.png',
    },
    name: {
      type: String,
      required: true,
    },
    priceBase: {
      type: Number,
      default: 0,
    },
    price: {
      type: Number,
      default: 0,
    },
    percentDiscount: {
      type: Number,
      default: 0,
    },
    query: {
      type: String,
      default: '',
    },
  },
  computed: {
    // показывать ли блок цены
    showPrices() {
      return this.priceBase !== 0 && this.priceBase !== null
        && this.price !== 0 && this.price !== null;
    },
  },
};
</script>
